<template>
  <CreateLayout title="ساخت برند" :submitFunction="createBrand"/>
</template>

<script>
import {mapActions} from 'vuex';
import CreateLayout from "./CreateLayout";

export default {
  name: "CreateBrand",
  components: {CreateLayout},
  methods: {
    ...mapActions({
      createBrand: "Brand/createBrand"
    })
  }
};
</script>

<style scoped>

</style>